import { RxCustomerAPI } from '@driftt/dapper'
import { parseCsvImport } from './models'

export const api = {
  upload(file) {
    const data = new FormData()
    data.append('file', file)
    return RxCustomerAPI.post('/csvimport', data, { file: true })
      .checkStatus()
      .mapResponse(parseCsvImport)
  },

  start(id, mapping, createSegment, csvName) {
    const name = csvName ? encodeURIComponent(csvName) : ''

    return RxCustomerAPI.post(`/csvimport/${id}/start${createSegment ? `?csvName=${name}&createSegment=true` : ``}`, mapping)
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(parseCsvImport)
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/csv/api.js